<template>
  <div class="detail">
    <div class="detail-banner">
      <div class="container">
        <h1>AI 财税</h1>
        <div class="sub">面向跨境企业的智能财税助手：多国算税 · 票据识别 · 合规预警</div>
      </div>
    </div>
    <div class="detail-body">
      <div class="container">
        <span class="detail-back" @click="$goBack()">‹ 返回</span>
        <div class="ai-grid">
          <div class="ai-feature" v-for="f in features" :key="f.title">
            <div class="ai-icon">{{ f.icon }}</div>
            <h3>{{ f.title }}</h3>
            <p>{{ f.desc }}</p>
          </div>
        </div>

        <div class="ai-jump">
          <p class="ai-jump-status">{{ status }}</p>
          <button class="btn-primary" :disabled="jumping" @click="enter">{{ btnText }}</button>
          <span class="ai-assistant-tip">将跳转至智能财税对话平台（clawtax），可在新窗口中使用。</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { openAiFinance } from '../api/home'

export default {
  name: 'AiFinance',
  data () {
    return {
      features: [
        { icon: '🧮', title: '多国算税', desc: '内置香港、新加坡、欧盟、中东等地税率模型，自动计算所得税与增值税。' },
        { icon: '🧾', title: '票据识别', desc: 'OCR 自动识别多语种发票，结构化入账，减少手工录入差错。' },
        { icon: '⚠️', title: '合规预警', desc: '实时监控申报节点与政策变化，到期前主动提醒，规避滞纳金与罚款。' },
        { icon: '📊', title: '经营看板', desc: '多主体财务数据汇总，跨境利润与现金流一目了然。' }
      ],
      status: '正在为你进入 AI 财税助手…',
      jumping: false
    }
  },
  computed: {
    btnText () {
      return this.jumping ? '正在跳转…' : '进入 AI 财税助手 ›'
    }
  },
  mounted () {
    // 与小程序 ai_finance 组件一致：进入页面即获取 token 并跳转
    this.enter()
  },
  methods: {
    async enter () {
      if (this.jumping) return
      this.jumping = true
      this.status = '正在获取访问凭证…'
      try {
        await openAiFinance()
        this.status = '已在新窗口打开，如未自动跳转请点击上方按钮。'
      } catch (e) {
        this.status = '跳转失败，请点击按钮重试。'
      } finally {
        this.jumping = false
      }
    }
  }
}
</script>

<style scoped>
.ai-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  margin-bottom: 32px;
}
.ai-feature {
  background: #fff;
  border: 1px solid #e6ebf5;
  border-radius: 14px;
  padding: 24px;
  box-shadow: 0 6px 22px rgba(36, 68, 203, 0.08);
  text-align: center;
}
.ai-icon {
  font-size: 34px;
  margin-bottom: 12px;
}
.ai-feature h3 {
  color: #2444cb;
  font-size: 17px;
  margin-bottom: 8px;
}
.ai-feature p {
  font-size: 13.5px;
  color: #5b6b8c;
  line-height: 1.7;
}
.ai-jump {
  background: #fff;
  border: 1px solid #e6ebf5;
  border-radius: 14px;
  padding: 28px;
  box-shadow: 0 6px 22px rgba(36, 68, 203, 0.08);
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
}
.ai-jump-status {
  flex: 1 1 200px;
  font-size: 15px;
  color: #1f2a44;
  margin: 0;
}
.ai-assistant-tip {
  color: #9aa6c0;
  font-size: 13px;
}
@media (max-width: 768px) {
  .ai-grid { grid-template-columns: 1fr 1fr; }
}
@media (max-width: 480px) {
  .ai-grid { grid-template-columns: 1fr; }
}
</style>
